<section class="upload-history-section">
  <div class="history-heading">
    <h2>Upload History</h2>
    <p nz-typography>All the data files that have been exported till date</p>
  </div>

  <div class="history-panel">
    <div class="history-toolbar">
      <nz-input-group class="search-control" nzPrefixIcon="search">
        <input nz-input type="text" placeholder="Search" [(ngModel)]="searchText" />
      </nz-input-group>

      <div class="filter-controls">
        <nz-select
          class="status-control"
          nzPlaceHolder="All Status"
          [(ngModel)]="selectedStatus"
          (ngModelChange)="onStatusChange($event)"
        >
          <nz-option nzLabel="All Status" [nzValue]="null"></nz-option>
          <nz-option nzLabel="Completed" [nzValue]="uploadStatus.COMPLETED"></nz-option>
          <nz-option nzLabel="Failed" [nzValue]="uploadStatus.FAILED"></nz-option>
        </nz-select>

        <ng-template #dateRangeSeparator>
          <span class="date-range-separator" nz-icon nzType="arrow-right" nzTheme="outline"></span>
        </ng-template>

        <nz-range-picker
          class="date-control"
          [nzPlaceHolder]="dateRangePlaceholders"
          [nzSeparator]="dateRangeSeparator"
          [(ngModel)]="selectedDateRange"
          (ngModelChange)="onDateRangeChange($event)"
        ></nz-range-picker>
      </div>
    </div>

    <nz-table
      #historyTable
      nzSize="middle"
      class="history-table"
      [nzData]="filteredUploadHistory"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      [nzLoading]="isLoading"
    >
      <thead>
        <tr>
          <th [nzSortFn]="sortByFileId">Batch Id</th>
          <th
            *ngIf="isNflAdmin"
            [nzSortFn]="sortByOrgName"
            [nzFilterFn]="filterByOrgName"
            [nzFilterMultiple]="false"
            [nzFilters]="filterList"
          >
            Organization
          </th>
          <th [nzSortFn]="sortByRecordCount">No. of Rows</th>
          <th [nzSortFn]="sortByUploadedAt" nzSortOrder="descend">Upload Date</th>
          <th [nzSortFn]="sortByUploadBy">Uploaded By</th>
          <th [nzSortFn]="sortByProcessStatus">Process Status</th>
          <th [nzSortFn]="sortByPublishStatus">Publish Status</th>
          <th [nzSortFn]="sortByStatusMessage">Status Message</th>
          <th>Validation Logs</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let upload of historyTable.data">
          <td class="batch-id">{{ upload.fileId }}</td>
          <td *ngIf="isNflAdmin">{{ getOrgNameValue(upload.orgId) || upload.orgId }}</td>
          <td>{{ upload.recordCount ?? 0 }}</td>
          <td>{{ upload.uploadedAt | date: 'medium' }}</td>
          <td>{{ getUploadedBy(upload) }}</td>
          <td>
            <nz-tag class="status-tag" [ngClass]="getStatusTagClass(upload.uploadStatus)">
              <span nz-icon [nzType]="getStatusIconType(upload.uploadStatus)"></span>
              {{ getUploadStatusLabel(upload.uploadStatus) }}
            </nz-tag>
          </td>
          <td>
            <nz-tag class="status-tag" [ngClass]="getStatusTagClass(upload.exportStatus)">
              <span nz-icon [nzType]="getStatusIconType(upload.exportStatus)"></span>
              {{ getExportStatusLabel(upload.exportStatus) }}
            </nz-tag>
          </td>
          <td class="status-message" [ngClass]="getStatusMessageClass(upload)">
            {{ getStatusMessage(upload) }}
          </td>
          <td class="view-logs">
            <span
              nz-icon
              nzType="eye"
              nzTheme="outline"
              nz-tooltip
              nzTooltipTitle="View Validation Logs"
              (click)="showModal(upload)"
            ></span>
          </td>
        </tr>
      </tbody>
    </nz-table>
    <div class="pagination">
      <!-- <nz-select [(ngModel)]="pageIndex" (ngModelChange)="onPageSizeChange($event)">
        <nz-option nzValue="10" nzLabel="10 / page"></nz-option>
        <nz-option nzValue="20" nzLabel="20 / page"></nz-option>
        <nz-option nzValue="50" nzLabel="50 / page"></nz-option>
      </nz-select> -->
      <button nz-button nzType="primary" [disabled]="pageIndex === 1 || isLoading" (click)="previousPage()">
        <span nz-icon nzType="double-left" nzTheme="outline"></span> Previous
      </button>
      <!-- <span>Page {{ pageIndex }}</span> -->
      <button nz-button nzType="primary" [disabled]="!hasNextPage || isLoading" (click)="nextPage()">
        Next
        <span nz-icon nzType="double-right" nzTheme="outline"></span>
      </button>
    </div>
  </div>
</section>
